module.exports = __webpack_public_path__ + "img/icon1.a3dc964f.png";